import { useEffect, useState } from "react";
import { siteConfig } from "@/data/siteConfig";
import { scrollToId } from "./shared";
import { Menu, X } from "lucide-react";

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-navy/90 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-3 text-left"
        >
          <span className="flex h-9 w-9 items-center justify-center border border-gold text-gold font-display text-lg">
            M
          </span>
          <span className="hidden sm:block leading-tight text-cream">
            <span className="block font-display text-base tracking-tight">
              My Brother's Keepers Club
            </span>
            <span className="block text-[10px] uppercase tracking-[0.28em] text-gold/80">
              Founded by Ollie Howie
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {siteConfig.nav.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              onClick={() => go(n.href)}
              className="text-sm text-cream/80 hover:text-cream transition-colors duration-300 tracking-wide"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="header-apply-btn"
            onClick={() => go("#apply")}
            className="bg-gold text-navy px-6 py-2.5 text-sm font-semibold tracking-wide hover:bg-cream transition-colors duration-300"
          >
            {siteConfig.primaryCta}
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-cream"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-navy/98 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {siteConfig.nav.map((n) => (
            <button
              key={n.href}
              data-testid={`mobile-nav-${n.href.replace("#", "")}`}
              onClick={() => go(n.href)}
              className="text-left text-cream/85 text-lg font-display"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="mobile-header-apply-btn"
            onClick={() => go("#apply")}
            className="mt-2 bg-gold text-navy px-6 py-3 font-semibold"
          >
            {siteConfig.primaryCta}
          </button>
        </div>
      )}
    </header>
  );
};
